'use client';



import { useTranslations } from 'next-intl';

import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Divider, Flex, Text, Transition } from '@mantine/core';

import classes from './AiWaitingModal.module.css';

import { useAppContext } from '@/context/AppContext';

interface AiWaitingContentProps {
    sentences: Array<any>;
    index: number;
    mounted: boolean;
    handleExited: () => void;
    onLike: (id: string, links: Array<any>) => void;
}

const AiWaitingContent = ({
    sentences,
    index,
    mounted,
    handleExited,
    onLike,
}: AiWaitingContentProps) => {
    const t = useTranslations();
    const [user] = useAppContext('user');
    
    return (<Flex direction="column" justify="center" align="center" gap="md" p="xs">
        <Text ta="center">
            {t('processing-in-progress').toUpperCase()}
        </Text>
        <video src="/images/logo.webm" width={60} height={60} loop autoPlay muted />
        <Box h={100}>
            {
                sentences.length > 0 && (
                    <Transition
                        transition={mounted ? 'fade-right' : 'fade-left' }
                        mounted={mounted}
                        duration={500}
                        enterDelay={300}
                        onExited={handleExited}
                    >
                        {(styles) => (
                            <Flex direction="column" justify="center" align="center" gap="md" style={styles}>
                                <Text ta="center">
                                    {sentences[index].text}
                                </Text>
                                {
                                    sentences[index].text && (
                                        <Flex align="center" h={30}>
                                            <Button size="xs" disabled={sentences[index].likedByUsers?.includes(user?._id)} onClick={() => onLike(sentences[index]._id, sentences[index]._links)} className={`${classes.button}${sentences[index].likedByUsers?.includes(user?._id) ? ` ${classes.buttonLiked}` : ''}`}>
                                                <Flex justify="space-between" align="center" gap="xl" w="100%">
                                                    <Flex gap="xs" align="center">
                                                        <FontAwesomeIcon icon={faThumbsUp} className={`${classes.icon}${sentences[index].likedByUsers?.includes(user?._id) ? ` ${classes.iconLiked}` : ''}`} />
                                                        <Text className={`${classes.text}${sentences[index].likedByUsers?.includes(user?._id) ? ` ${classes.textLiked}` : ''}`}>
                                                            {t(sentences[index].likedByUsers?.includes(user?._id) ? 'liked' : 'like')}
                                                        </Text>
                                                    </Flex>
                                                    <Flex justify="center" align="center">
                                                        <Divider orientation="vertical" color={sentences[index].likedByUsers?.includes(user?._id) ? 'nli-liberty' : 'white' } />
                                                        <Text ml="md" className={`${classes.text}${sentences[index].likedByUsers?.includes(user?._id) ? ` ${classes.textLiked}` : ''}`}>
                                                            {sentences[index].likes}
                                                        </Text>
                                                    </Flex>
                                                </Flex>
                                            </Button>
                                        </Flex>
                                    )
                                }
                            </Flex>
                        )}
                    </Transition>
                )
            }
        </Box>
    </Flex>
    );
};


export default AiWaitingContent;